var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideInterested(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "66px",
    viewBox: "0 0 124 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "guideInterested") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.703243,6.27585982 L43.3678363,6.27585982 C46.5176504,6.27585982 49.0710792,8.83438707 49.0710792,11.9904904 L49.0710792,54.8502196 C49.0710792,58.006323 46.5176504,60.5648502 43.3678363,60.5648502 L17.703243,60.5648502 C14.5534288,60.5648502 12,58.006323 12,54.8502196 L12,11.9904904 C12,8.83438707 14.5534288,6.27585982 17.703243,6.27585982 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.0%",
    y: "-2.8%",
    width: "108.1%",
    height: "105.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.231063179 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.843868,6.00632857 L109.508461,6.00632857 C112.658275,6.00632857 115.211704,8.56485582 115.211704,11.7209591 L115.211704,54.5806884 C115.211704,57.7367917 112.658275,60.295319 109.508461,60.295319 L83.843868,60.295319 C80.6940538,60.295319 78.140625,57.7367917 78.140625,54.5806884 L78.140625,11.7209591 C78.140625,8.56485582 80.6940538,6.00632857 83.843868,6.00632857 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.0%",
    y: "-2.8%",
    width: "108.1%",
    height: "105.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.231063179 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PopUP-Not-interested-Copy-2",
    transform: "translate(-126.000000, -363.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guideInterested",
    transform: "translate(124.000000, 362.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4-Copy-2",
    transform: "translate(30.535540, 33.420355) rotate(-30.000000) translate(-30.535540, -33.420355) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M17.703243,7.27585982 C15.1061606,7.27585982 13,9.38622579 13,11.9904904 L13,54.8502196 C13,57.4544842 15.1061606,59.5648502 17.703243,59.5648502 L43.3678363,59.5648502 C45.9649186,59.5648502 48.0710792,57.4544842 48.0710792,54.8502196 L48.0710792,11.9904904 C48.0710792,9.38622579 45.9649186,7.27585982 43.3678363,7.27585982 L17.703243,7.27585982 Z",
    strokeLinejoin: "square",
    fillOpacity: 0.6,
    fill: "#E02828",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4-Copy-3",
    transform: "translate(96.676165, 33.150824) rotate(-330.000000) translate(-96.676165, -33.150824) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M83.843868,7.00632857 C81.2467856,7.00632857 79.140625,9.11669454 79.140625,11.7209591 L79.140625,54.5806884 C79.140625,57.184953 81.2467856,59.295319 83.843868,59.295319 L109.508461,59.295319 C112.105544,59.295319 114.211704,57.184953 114.211704,54.5806884 L114.211704,11.7209591 C114.211704,9.11669454 112.105544,7.00632857 109.508461,7.00632857 L83.843868,7.00632857 Z",
    strokeLinejoin: "square",
    fillOpacity: 0.6,
    fill: "#98D270",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "swipe-copy",
    transform: "translate(63.000000, 54.500000) rotate(-360.000000) translate(-63.000000, -54.500000) translate(44.000000, 42.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7845047,4.02486003 L29.2494155,4.02486003 C28.932028,4.02486003 28.6744201,3.63845859 28.6744201,3.16239002 C28.6744201,2.68632146 28.932028,2.29992002 29.2494155,2.29992002 L35.8225746,2.29992002 L34.5935047,0.981356282 C34.369301,0.757083243 34.369301,0.392477819 34.5935047,0.168204779 C34.8177084,-0.0560682598 35.182201,-0.0560682598 35.4064047,0.168204779 L37.7059474,2.52606572 C37.9301511,2.75033876 37.9301511,3.58456464 37.7059474,3.80889159 L35.5496101,6.19369352 C35.4369154,6.30529092 35.2897818,6.36162874 35.1425942,6.36162874 C34.9954067,6.36162874 34.848273,6.30523701 34.7355783,6.19369352 C34.5113747,5.96942048 34.5113747,5.60481506 34.7355783,5.38054202 L35.7845047,4.02486003 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1335409,10.522111 C28.6885179,10.522111 28.2737958,10.6586857 27.9294713,10.89138 C27.6328062,10.0414623 26.8282829,9.42966695 25.8851974,9.42966695 C25.4401744,9.42966695 25.0254522,9.56624166 24.6811278,9.79893589 C24.3844627,8.94901818 23.5799394,8.33722286 22.6368539,8.33722286 C22.2427385,8.33722286 21.8724273,8.44430113 21.5540896,8.63111198 L21.5540896,5.0598394 C21.5540896,3.85483768 20.5828349,2.87490002 19.3885104,2.87490002 C18.1941858,2.87490002 17.2229311,3.85483768 17.2229311,5.0598394 L17.2229311,14.3457421 L15.3410744,12.9222823 C14.2258267,12.0777928 12.6384526,12.1903504 11.6498903,13.186675 C11.0164633,13.8257648 11.0164633,14.8646953 11.6498903,15.5037851 L19.3603919,23.2842935 C20.280739,24.2128684 21.5053645,24.7241402 22.8068844,24.7241402 L25.3438407,24.7241402 C28.6268501,24.7241402 31.2991202,22.0290556 31.2991202,18.7156209 L31.2991202,12.7070504 C31.2991202,11.5020487 30.3278655,10.522111 29.1335409,10.522111 Z M30.2163559,18.7155697 C30.2163559,21.4259658 28.0302207,23.6316449 25.3438407,23.6316449 L22.8068844,23.6316449 C21.7934012,23.6316449 20.8416366,23.2340061 20.1259351,22.5118551 L12.4154335,14.731398 C12.2042912,14.5183681 12.2042912,14.1720408 12.4154335,13.9590109 C12.7510787,13.6214404 13.1993501,13.4477391 13.649804,13.4477391 C14.015801,13.4477391 14.3839297,13.5624475 14.6925223,13.7962171 L17.439555,15.8751536 C17.6041547,15.9996942 17.8250421,16.0182831 18.0069493,15.9265164 C18.1899224,15.8336742 18.3057969,15.6446614 18.3057969,15.4381862 L18.3057969,5.0598394 C18.3057969,4.45787623 18.7908659,3.96739532 19.3885611,3.96739532 C19.9862563,3.96739532 20.4713254,4.45792744 20.4713254,5.0598394 L20.4713254,13.2532981 C20.4713254,13.5548173 20.7138853,13.7995457 21.0127329,13.7995457 C21.3115805,13.7995457 21.5541404,13.5548173 21.5541404,13.2532981 L21.5541404,10.5221622 C21.5541404,9.92019908 22.0392094,9.42971816 22.6369047,9.42971816 C23.2345999,9.42971816 23.7196689,9.92025029 23.7196689,10.5221622 L23.7196689,13.2532981 C23.7196689,13.5548173 23.9622288,13.7995457 24.2610764,13.7995457 C24.559924,13.7995457 24.8024839,13.5548173 24.8024839,13.2532981 L24.8024839,11.6146063 C24.8024839,11.0126432 25.287553,10.5221622 25.8852482,10.5221622 C26.4829434,10.5221622 26.9680124,11.0126944 26.9680124,11.6146063 L26.9680124,13.2532981 C26.9680124,13.5548173 27.2105723,13.7995457 27.5094199,13.7995457 C27.8082675,13.7995457 28.0508274,13.5548173 28.0508274,13.2532981 L28.0508274,12.7070504 C28.0508274,12.1050872 28.5358965,11.6146063 29.1335917,11.6146063 C29.7312869,11.6146063 30.2163559,12.1051385 30.2163559,12.7070504 L30.2163559,18.7155697 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(5.199680, 3.500000) scale(-1, 1) translate(-5.199680, -3.500000) translate(0.199680, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.1089528,4.02486003 L0.574995405,4.02486003 C0.25760786,4.02486003 0,3.63845859 0,3.16239002 C0,2.68632146 0.25760786,2.29992002 0.574995405,2.29992002 L7.14702271,2.29992002 L5.91795279,0.981356282 C5.69374913,0.757083243 5.69374913,0.392477819 5.91795279,0.168204779 C6.14215646,-0.0560682598 6.5066491,-0.0560682598 6.73085277,0.168204779 L9.03039552,2.52606572 C9.25459919,2.75033876 9.25459919,3.58456464 9.03039552,3.80889159 L6.8740582,6.19369352 C6.76136352,6.30529092 6.61422986,6.36162874 6.46704231,6.36162874 C6.31985476,6.36162874 6.1727211,6.30523701 6.06002642,6.19369352 C5.83582276,5.96942048 5.83582276,5.60481506 6.06002642,5.38054202 L7.1089528,4.02486003 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideInterested);
export default __webpack_public_path__ + "static/media/guideInterested.88e490f47ae139d864e1214772f0d090.svg";
export { ForwardRef as ReactComponent };